<template><div><h1 id="artikelliste-nach-monaten" tabindex="-1"><a class="header-anchor" href="#artikelliste-nach-monaten"><span>Artikelliste nach Monaten</span></a></h1>
<p>Artikelliste nach Monaten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste mit Angaben zu Verkaufsmengen und -umsätzen pro Artikeltyp, kumuliert nach Monaten. Die Artikeltypen sind fest programmiert und haben folgende Bedeutung:</p>
<ul>
<li>
<p>N = normale Artikel</p>
</li>
<li>
<p>A = assemblierte Artikel</p>
</li>
<li>
<p>F = fiktive Artikel (Dienstleistungen)</p>
</li>
</ul>
<p>Es gibt drei Detaillierungsebenen dieser Auswertung:</p>
<ul>
<li>
<p>nur Totalwerte (zeigt relevante Werte für den Produktmanager wie aktueller Lagerwert, Verkaufsmenge, Deckungsbeitrag, vor- und reservierte Werte pro Artikeltyp)</p>
</li>
<li>
<p>mit Gruppenwerten (zeigt pro Artikelgruppe zusätzliche Details wie Umsätze und Deckungsbeiträge je für Wiederverkäufer- und Normalkundenaufträge)</p>
</li>
<li>
<p>mit Detailwerten pro Artikel, analog zu Gruppenwerten</p>
</li>
</ul>
<p>Standardsortierung erfolgt nach Artikeltypen, innerhalb dieser Gruppen kann Sortierung nach Productmanager oder Artikelgruppe gewählt werden.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Artikelliste nach Monaten</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>ArtGruppe von</dt>
<dd>von Artikelgruppe, leer = alle</dd>
<dt>ArtGruppe bis</dt>
<dd>bis Artikelgruppe, leer = alle</dd>
<dt>PM</dt>
<dd>Produkt Manager, leer = alle</dd>
<dt>von Monat,Jahr</dt>
<dd>Monat, Jahr, inklusive</dd>
<dt>bis Monat,Jahr</dt>
<dd>Monat, Jahr, inklusive</dd>
<dt>Sortiert nach</dt>
<dd>zusätzliche Sortierung nach P = Produktmanager, A = Artikelgruppe</dd>
<dt>Artikeldetail</dt>
<dd>D = mit Artikeldetail G = Gruppenwerte T = Totalwerte</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-listen" tabindex="-1"><a class="header-anchor" href="#output-listen"><span>Output (Listen)</span></a></h2>
<p>Output bei D = &quot;mit Detailwerten&quot; bzw. bei G = &quot;mit Gruppenwerten&quot;</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>PM</td>
<td>Produkt Manager</td>
</tr>
<tr>
<td>WGr</td>
<td>Artikelgruppe</td>
</tr>
<tr>
<td>Artikel</td>
<td>Artikelnummer nur bei &quot;D&quot;, sonst &quot;Gr-Total&quot;</td>
</tr>
<tr>
<td>AT</td>
<td>Artikeltyp</td>
</tr>
<tr>
<td>VerkMenge</td>
<td>Verkaufsmenge</td>
</tr>
<tr>
<td>Verk.Wert Total</td>
<td>Verkaufswert aus Aufträgen &quot;Wiederverkauf&quot; und &quot;normaler Kunde&quot; (Summe aus [Verk.Wert Wverkauf] + [Verk.Wert übrige])</td>
</tr>
<tr>
<td>Verk.Wert Wverkauf</td>
<td>Verkaufswert aus Aufträgen &quot;Wiederverkauf&quot;</td>
</tr>
<tr>
<td>Verk.Wert übrige</td>
<td>Verkaufswert aus &quot;normalen&quot; Kundenaufträgen</td>
</tr>
<tr>
<td>DB% Tot</td>
<td>Deckungsbeitrag Total in %. Der DB errechnet sich aus [Verk.Wert Total] - [Einkaufspreis im Artikelstamm * Verkaufsmenge]</td>
</tr>
<tr>
<td>DB% Läd</td>
<td>Deckungsbeitrag &quot;Wiederverkauf&quot; in %</td>
</tr>
<tr>
<td>DB% übr</td>
<td>Deckungsbeitrag &quot;normale&quot; Kundenaufträge in %</td>
</tr>
<tr>
<td>Zeilen</td>
<td>Zeilen</td>
</tr>
<tr>
<td>Gr.Total</td>
<td>am Ende jeder Artikelgruppe erscheint das Gruppentotal der einzelnen Spalten</td>
</tr>
<tr>
<td>Total</td>
<td>pro Artikeltyp (N, A, F) Totalwerte der einzelnen Spalten</td>
</tr>
</tbody>
</table>
<p>Output bei T = nur Totalwerte pro Artikeltyp (N, A, F) (wird auch bei Details und Gruppenwerten jeweils ausgewiesen)</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Totalwerte</td>
<td>Gesamtwerte aus Wiederverkauf = [WVerk] und &quot;normalen&quot; Kundenaufträgen = [übrige]</td>
</tr>
<tr>
<td>WVerk</td>
<td>Werte aus Wiederverkaufs-Aufträgen</td>
</tr>
<tr>
<td>Übrige</td>
<td>Werte aus &quot;normalen&quot; Kundenaufträgen</td>
</tr>
<tr>
<td>Zeilen</td>
<td>Zeilen</td>
</tr>
<tr>
<td>Lagerwert</td>
<td>Gesamtwert des Lagers zu Einkaufspreisen (= [verkaufbare Menge] * [Einkaufspreis aus Artikelstamm])</td>
</tr>
<tr>
<td>Einkaufswert</td>
<td>der verkauften Artikel (= [Einkaufspreis aus Artikelstamm] * [Verkaufsmenge])</td>
</tr>
<tr>
<td>Verkaufsmenge</td>
<td>&gt;effektiv verkaufte Menge (Anzahl Stück)</td>
</tr>
<tr>
<td>Verkaufswert</td>
<td>Verkaufspreis effektiv verkaufte Menge (Rabatte berücksichtigt)</td>
</tr>
<tr>
<td>Deckungsbeitrag %</td>
<td>Gesamt-Deckungsbeitrag in %. Der DB errechnet sich aus [Verkaufswert] - [Einkaufspreis im Artikelstamm * Verkaufsmenge]</td>
</tr>
<tr>
<td>Deckungsbeitrag Fr.</td>
<td>Gesamt-Deckungsbeitrag in Fr.</td>
</tr>
<tr>
<td>Vorreserve Wert</td>
<td>&gt;Wert vorreservierte Artikel (= [Anzahl vorreservierte Artikel] * [Verkaufspreis im Artikelstamm])</td>
</tr>
<tr>
<td>Reservierter Wert</td>
<td>Wert reservierte Artikel (= [Anzahl reservierte Artikel] * [Verkaufspreis im Artikelstamm])</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel mit Gruppenwerten</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Stamm: Lagerliste                           05.03.1999 14:03:06 roo  Seite     0</span>
<span class="line"></span>
<span class="line">Zeitraum:  3-1997 bis  5-1997   Verkaufstatistik</span>
<span class="line"></span>
<span class="line">                   A              Verk.Wert   Verk.Wert   Verk.Wert DB% DB% DB%</span>
<span class="line">PM  WGr   Artikel  T  VerkMenge       Total    WVerkauf      übrige Tot Läd übr</span>
<span class="line">--- ----- -------- - ---------- ----------- ----------- ----------- --- --- ---</span>
<span class="line">.</span>
<span class="line">rs  100   Gr-Total N          0           0           0           0   0   0   0</span>
<span class="line">sg  100   Gr-Total N     36,387   1,733,755     332,020   1,401,735  56  42  59</span>
<span class="line">tb  100   Gr-Total N          0           0           0           0   0   0   0</span>
<span class="line">we  22000 Gr-Total N     42,048     957,297     239,576     717,722  51  35  57</span>
<span class="line"></span>
<span class="line">          Total    N    119,377   3,781,160     884,557   2,896,603  54  38  59</span>
<span class="line"></span>
<span class="line">                    Totalwerte          WVerk         Übrige</span>
<span class="line">Artikeltyp                   N</span>
<span class="line">Lagerwert            3,184,051</span>
<span class="line">Einkaufswert         1,743,970</span>
<span class="line">Verkaufsmenge          119,377         39,081         80,296</span>
<span class="line">Verkaufswert         3,781,160        884,557      2,896,603</span>
<span class="line">Deckungsbeitrag %           53.9           38.5           58.6</span>
<span class="line">Deckungsbeitrag Fr.  2,037,190        340,340      1,696,849</span>
<span class="line">Vorreserve Wert        294,465</span>
<span class="line">Reservierter Wert      453,027</span>
<span class="line">                   A              Verk.Wert   Verk.Wert   Verk.Wert DB% DB% DB%</span>
<span class="line">PM  WGr   Artikel  T  VerkMenge       Total    WVerkauf      übrige Tot Läd übr</span>
<span class="line">--- ----- -------- - ---------- ----------- ----------- ----------- --- --- ---</span>
<span class="line">af  100   Gr-Total A          0           0           0           0   0   0   0</span>
<span class="line">an  56210 Gr-Total A        398      20,928       1,552      19,376 100 100 100</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Der Produktmanager &quot;sg&quot; hat von der Artikelgruppe 100 rund 36'000 Stück verkauft und damit 1,7 Mio. Fr. Umsatz gemacht. Davon waren 332'020 Franken Umsatz mit Wiederverkäufern. Bei diesen betrug der Deckungsbeitrag lediglich 42 % im Gegensatz zu den normalen Kunden, bei welchen ein Deckungsbeitrag von 59 % erreicht wurde. Insgesamt ergibt sich für diese Artikelgruppe ein Gesamtdeckungsbeitrag von 56 %.</p>
<p>Outputbeispiel mit Detailwerten</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Stamm: Lagerliste                           05.03.1999 14:03:58 roo  Seite     0</span>
<span class="line"></span>
<span class="line">Zeitraum:  3-1997 bis  5-1997   Verkaufstatistik</span>
<span class="line"></span>
<span class="line">                   A              Verk.Wert   Verk.Wert   Verk.Wert DB% DB% DB%</span>
<span class="line">PM  WGr   Artikel  T  VerkMenge       Total    WVerkauf      übrige Tot Läd übr</span>
<span class="line">--- ----- -------- - ---------- ----------- ----------- ----------- --- --- ---</span>
<span class="line">    100   0001.01  N          0           0           0           0   0   0   0</span>
<span class="line">    100   0002.00  N          0           0           0           0   0   0   0</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line">    96220 0584.03  A         23         150         123          27 100 100 100</span>
<span class="line">    96220 0584.04  A         24         153         135          18 100 100 100</span>
<span class="line">    96220 0584.05  A         49         495         207         288 100 100 100</span>
<span class="line">    96220 Gr-Total A        113         909         558         351 100 100 100</span>
<span class="line"></span>
<span class="line">    96410 2242.91  A         63       2,933         336       2,597 100 100 100</span>
<span class="line">    96410 2242.92  A          1          27          27           0 100 100   0</span>
<span class="line">    96410 2319.94  A         45       1,215           0       1,215 100   0 100</span>
<span class="line">    96410 Gr-Total A        109       4,175         363       3,812 100 100 100</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">          Total    A      5,936     153,379      33,638     119,741 100 100 100</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                    Totalwerte          WVerk         Übrige</span>
<span class="line">Artikeltyp                   A</span>
<span class="line">Lagerwert                    0</span>
<span class="line">Einkaufswert                 0</span>
<span class="line">Verkaufsmenge            5,936          1,879          4,057</span>
<span class="line">Verkaufswert           153,379         33,638        119,741</span>
<span class="line">Deckungsbeitrag %          100.0          100.0          100.0</span>
<span class="line">Deckungsbeitrag Fr.    153,379         33,638        119,741</span>
<span class="line">Vorreserve Wert          3,600</span>
<span class="line">Reservierter Wert       12,719</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Vom Artikel 2242.91 der Warengruppe 96410 wurden im Quartal März bis Mai 1997 63 Stück verkauft. Vom Gesamtumsatz von 2'933 Franken entfielen 336 Franken auf Aufträge von Wiederverkäufern. Der Deckungsbeitrag betrug 100%.</p>
<p>Outputbeispiel nur Totalwerte</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Stamm: Lagerliste                           05.03.1999 14:04:32 leh  Seite     0</span>
<span class="line"></span>
<span class="line">Zeitraum:  3-1997 bis  5-1997   Verkaufstatistik</span>
<span class="line"></span>
<span class="line">                    Totalwerte          WVerk         Übrige</span>
<span class="line">Artikeltyp                   N</span>
<span class="line">Lagerwert            3,184,051</span>
<span class="line">Einkaufswert         1,743,970</span>
<span class="line">Verkaufsmenge          119,377         39,081         80,296</span>
<span class="line">Verkaufswert         3,781,160        884,557      2,896,603</span>
<span class="line">Deckungsbeitrag %           53.9           38.5           58.6</span>
<span class="line">Deckungsbeitrag Fr.  2,037,190        340,340      1,696,849</span>
<span class="line">Vorreserve Wert        294,465</span>
<span class="line">Reservierter Wert      453,027</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Mit den ausgewerteten Normalartikeln (Artikeltyp N) wurde ein Gesamtumsatz von knapp 3,8 Mio. Franken getätigt. Dies entspricht einem Einkaufswert der verkauften Waren von gut 1,7 Mio. Franken. Insgesamt sind von diesem Artikeltyp noch Waren im Verkaufswert von knapp 3,2 Mio. Franken an Lager. Für Normalartikel sind Aufträge im System vorhanden, die aufgrund der Lagersituation nicht geliefert werden können. Deshalb sind Waren im Verkaufswert von knapp 300'000 Franken vorreserviert. Waren im Wert von 450'000 Franken sind reserviert, warten also auf eine Fakturierung.</p>
</div></template>


